/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type onboardingStateGetOnboardingStateQuery$variables = {
  key?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type onboardingStateGetOnboardingStateQuery$data = {
  readonly onboardingState: ReadonlyArray<{
    readonly key: string;
    readonly value: string | null | undefined;
  }> | null | undefined;
};
export type onboardingStateGetOnboardingStateQuery = {
  response: onboardingStateGetOnboardingStateQuery$data;
  variables: onboardingStateGetOnboardingStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      }
    ],
    "concreteType": "OnboardingState",
    "kind": "LinkedField",
    "name": "onboardingState",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "onboardingStateGetOnboardingStateQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "onboardingStateGetOnboardingStateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
    "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
    "metadata": {},
    "name": "onboardingStateGetOnboardingStateQuery",
    "operationKind": "query",
    "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
  }
};
})();

(node as any).hash = "201bff99b2bdca3d23c658876502ced3";

export default node;
